import { useLayoutEffect } from 'react';

/*
 * We use this hook instead of React's `onKeyDownCapture` due to an issue with React 16.
 * React 18 resolves this, but the native event listener ensures compatibility with both versions.
 */
export const useKeydownListener = (
  ref: HTMLDivElement | null,
  handleKeyDown: (e: KeyboardEvent) => void
) => {
  useLayoutEffect(() => {
    if (!ref) {
      return;
    }

    ref.addEventListener('keydown', handleKeyDown, { capture: true });

    return () => {
      ref.removeEventListener('keydown', handleKeyDown, { capture: true });
    };
  }, [ref, handleKeyDown]);
};
